<template>
  <div>
      <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
        <v-card color="primary" dark>
          <v-card-text>
            {{progressMessage}}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog.dialogCriteria" max-width="1000px" scrollable eager>
        <v-card>
          <v-card-title>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-xs text-xs-center fluid>
              <v-row row wrap>  
                <v-col cols="12" xs="12" md="4" class="pt-2 pb-1 mb-1">
                  <v-dialog
                    ref="dialogDueDateFromTo"
                    v-model="dialog.dialogDueDateFromTo"
                    :return-value.sync="criteria.dueDateFromTo"
                    persistent
                    width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeTextdueDateFromTo"
                        label="Due Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearDueDateFromToCriteria"
                        clearable></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="criteria.dueDateFromTo"
                      range
                      scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialog.dialogDueDateFromTo = false">{{$t('cancel')}}</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogDueDateFromTo.save(criteria.dueDateFromTo)">{{$t('ok')}}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" xs="12" md="4" class="pt-2 pb-1 mb-1">
                  <v-dialog
                    ref="dialogReceivedDateFromTo"
                    v-model="dialog.dialogReceivedDateFromTo"
                    :return-value.sync="criteria.receivedDateFromTo"
                    persistent
                    width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeTextReceivedDateFromTo"
                        label="Received Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearReceivedDateFromToCriteria"
                        clearable></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="criteria.receivedDateFromTo"
                      range
                      scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialog.dialogReceivedDateFromTo = false">{{$t('cancel')}}</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogReceivedDateFromTo.save(criteria.receivedDateFromTo)">{{$t('ok')}}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col> 
                <v-col cols="12" xs="12" md="4" class="pt-2 pb-1 mb-1">
                  <v-dialog
                    ref="dialogSentDateFromTo"
                    v-model="dialog.dialogSentDateFromTo"
                    :return-value.sync="criteria.sentDateFromTo"
                    persistent
                    width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeTextSentDateFromTo"
                        label="Sent Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearSentDateFromToCriteria"
                        clearable></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="criteria.sentDateFromTo"
                      range
                      scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialog.dialogSentDateFromTo = false">{{$t('cancel')}}</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogSentDateFromTo.save(criteria.sentDateFromTo)">{{$t('ok')}}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col> 
              </v-row>
              <v-row row wrap>
                <v-col cols="12" xs="12" md="4" class="pt-2 pb-1 mb-1">
                  <v-dialog
                    ref="dialogDueDateOutLabFromTo"
                    v-model="dialog.dialogDueDateOutLabFromTo"
                    :return-value.sync="criteria.dueDateOutLabFromTo"
                    persistent
                    width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateRangeTextDueDateOutLabFromTo"
                        label="Due Date OutLab"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        @click:clear="clearDueDateOutLabFromToCriteria"
                        clearable></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="criteria.dueDateOutLabFromTo"
                      range
                      scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialog.dialogDueDateOutLabFromTo = false">{{$t('cancel')}}</v-btn>
                      <v-btn text color="primary" @click="$refs.dialogDueDateOutLabFromTo.save(criteria.dueDateOutLabFromTo)">{{$t('ok')}}</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col> 
                <v-col cols="12" xs="12" md="4">
                  <v-text-field label="Customer" v-model="criteria.custName"
                    outlined dense hide-details readonly
                    @click:clear="clearCustomerCriteria"
                    clearable>
                    <template v-slot:append>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" color="blue" @click="browseCustomerCriteria">mdi-file-find</v-icon>
                        </template>
                        Search Customer
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-text-field label="Supplier" v-model="criteria.vendorName"
                    outlined dense hide-details readonly
                    @click:clear="clearSupplierCriteria"
                    clearable>
                    <template v-slot:append>
                        <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" color="blue" @click="browseSupplierCriteria">mdi-file-find</v-icon>
                        </template>
                        Search Supplier
                        </v-tooltip>
                    </template>
                    </v-text-field>
                </v-col>
              </v-row>
              <v-row row wrap>
                <!-- <v-col cols="12" sm="12" md="4">
                    <v-menu v-model="menu.menuCompleteDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field dense hide-details outlined v-model="criteria.completeDate" label="Complete Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="criteria.completeDate" @input="menu.menuCompleteDate = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col> -->
                <v-col cols="12" xs="12" md="4">
                    <v-text-field label="HN" v-model="criteria.hn" outlined dense hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                    <v-checkbox v-model="criteria.complete" label="Complete" hide-details>
                    </v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click="clearAll" style="text-transform: capitalize">Clear All</v-btn>
            <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveOutLabProcessing()">
              <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
            </v-btn>
            <v-btn outlined color="primary" style="text-transform: capitalize" @click="dialog.dialogCriteria = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowseCustomer" max-width="800px" scrollable eager>
        <CustomerBrowse ref="CustomerBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </CustomerBrowse>
      </v-dialog>
      <v-dialog v-model="dialog.dialogBrowseSupplier" max-width="800px" scrollable eager>
        <SupplierBrowse ref="SupplierBrowse"
          :receiveVar="sendVar" @eventReturn="getVarReturn">
        </SupplierBrowse>
      </v-dialog>
    <v-toolbar scrollable color="light-blue darken-4" dark>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="openDialogCriteria" style="text-transform: capitalize">
        <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>Criteria
      </v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          color="primary"
          dark
          v-bind="attrs"
          v-on="on">
          <v-icon dark>list</v-icon>
        </v-btn>
      </template>
        <v-list>
          <v-list-tile @click="complete">
            <img src="../assets/SoftwareClinicIcon/Query.png" height="30" weight="30"/>
            <v-list-tile-title>&nbsp;Complete</v-list-tile-title>
          </v-list-tile>
          <v-divider light></v-divider>
          <v-list-tile @click="VoidTestItem">
            <img src="../assets/SoftwareClinicIcon/RED_Urgent.png" height="30" weight="30"/>
            <v-list-tile-title>&nbsp;Void Test Item</v-list-tile-title>
          </v-list-tile>
          <v-divider light></v-divider>
          <v-list-tile>
            <img src="../assets/SoftwareClinicIcon/chemistry2.png" height="30" weight="30"/>
            <v-list-tile-title>&nbsp;View Job</v-list-tile-title>
          </v-list-tile>
          <v-divider light></v-divider>
          <v-list-tile>
            <img src="../assets/SoftwareClinicIcon/edit-icon-2375785_960_720.png" height="30" weight="30"/>
            <v-list-tile-title>&nbsp;View Order Entry</v-list-tile-title>
          </v-list-tile>
          <v-divider light></v-divider>
          <v-list-tile>
            <img src="../assets/SoftwareClinicIcon/edit-icon-2375785_960_720.png" height="30" weight="30"/>
            <v-list-tile-title>&nbsp;View Order Manual Result By Category</v-list-tile-title>
          </v-list-tile>
          <v-divider light></v-divider>
          <v-list-tile>
            <img src="../assets/SoftwareClinicIcon/print-solid.png" height="30" weight="30"/>
            <v-list-tile-title>&nbsp;Delivery Order</v-list-tile-title>
          </v-list-tile>
          <v-divider light></v-divider>
          <v-list-tile>
            <img src="../assets/SoftwareClinicIcon/print-solid.png" height="30" weight="30"/>
            <v-list-tile-title>&nbsp;Print Result Form</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> 
    </v-toolbar>
    <v-container grid-list-xs text-xs-center fluid>
          <v-row row wrap>
            <v-col cols="12" sm="12" md="4">
                    <v-menu v-model="menu.menuCompleteDate" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field dense hide-details outlined v-model="criteria.completeDate" label="Complete Date" append-outer-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="criteria.completeDate" @input="menu.menuCompleteDate = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
          </v-row>
    </v-container> 
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      show-select
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="uid"
      class="fill-height">
      <template v-slot:header.data-table-select="{ on, props }">
        <tr>
          <td>
            <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
          </td>
          <td v-if="vDataTable.selected.length > 0">
            {{vDataTable.selected.length}}
          </td>
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title></v-toolbar-title>
          <v-toolbar-title>LIS OutLab Processing</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.data-table-select="{ isSelected, select }">
        <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
      </template>
      <template v-slot:item.data-table-no="{ item, index }">
        {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
      </template>
      <template v-slot:no-data>
        <v-alert type="info">
          {{$t('noData')}}
        </v-alert>
      </template>
      <template v-slot:no-results>
        <v-alert type="warning">
          {{stringFormat($t('searchNotFound'),vDataTable.search)}}
        </v-alert>
      </template>
      <template v-slot:footer>
        <tr class="sticky-table-footer" style="position: absolute">
          <td>Selected({{vDataTable.selected.length}})s</td> 
        </tr>
      </template>
    </v-data-table> 
  </div>
</template>
  <script>
  import { mapMutations, mapGetters, mapState } from 'vuex'
  import CustomerBrowse from '@/components/common/CustomerBrowse'
  import SupplierBrowse from '@/components/common/SupplierBrowse'
  export default {
    components: {
      CustomerBrowse,
      SupplierBrowse,
    },
  
    props: ['parentComponent'],
  
    data () {
      return {
        utils: require('@/utils'),
        stringFormat: require('string-format'),
        appName: process.env.VUE_APP_DB_APP_NAME,
        dialog: {
          dialogProgress: false,
          dialogAddEdit: false,
          dialogCriteria: false,
          dialogBrowseCustomer: false,
          dialogBrowseSupplier: false,
          dialogDueDateFromTo: false,
          dialogReceivedDateFromTo: false,
          dialogSentDateFromTo: false,
          dialogDueDateOutLabFromTo: false,
        },
        menu: {
          menuCompleteDate: false,
        },
        vDataTable: {
          search: '',
          selected: [],
          data: [],
          editedIndex: -1,
          editedItem: {
            win_name: '',
            window_comment: ''
          },
          defaultItem: {
            win_name: '',
            window_comment: ''
          },
          options: {
            page: 1,
            itemsPerPage: -1,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: true,
            multiSort: true,
            // mustSort: true
          },
        },
        sendVar: [],
        dropDownData: [],
        progressMessage: '',
        criteria: {
          receivedDateFromTo: [],
          dueDateFromTo: [],
          sentDateFromTo: [],
          dueDateOutLabFromTo: [],
          completeDate: '',
          custSkey: -1,
          custName: '',
          vendorSkey: -1,
          vendorName: '',
          hn: '',
          complete: false,
        },
      }
    },
    computed: {
      ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
      dateRangeTextdueDateFromTo () {
        return this.criteria.dueDateFromTo.join(' ~ ')
      },
      dateRangeTextReceivedDateFromTo () {
        return this.criteria.receivedDateFromTo.join(' ~ ')
      },
      dateRangeTextSentDateFromTo () {
        return this.criteria.sentDateFromTo.join(' ~ ')
      },
      dateRangeTextDueDateOutLabFromTo () {
        return this.criteria.dueDateOutLabFromTo.join(' ~ ')
      },
      formTitle () {
        return this.vDataTable.editedIndex === -1 ? 'New Issue Log' : 'Edit Issue Log'
      },
      headers () {
        return [
          { text: '#', align: 'center', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
          { text: '', align: 'center', value: 'data-table-select', class: 'text-xl-left body-1 black--text' },
          { text: 'Job Document No.', align: 'left', value: 'job_doc_no', class: 'text-xl-left body-1 black--text' },
          { text: 'Order No', align: 'left', value: 'order_id', class: 'text-xl-left body-1 black--text' },
          { text: 'Customer Name', width: '200', align: 'left', value: 'cust_name', class: 'text-xl-left body-1 black--text' },
          { text: 'Outlab Name', width: '200', align: 'left', value: 'vendor_name', class: 'text-xl-left body-1 black--text' },
          { text: 'HN', width: '200', align: 'left', value: 'hn', class: 'text-xl-left body-1 black--text' },
          { text: 'Patient', align: 'left', value: 'patient_name', class: 'text-xl-left body-1 black--text' },
          { text: 'Age', width: '200', align: 'left', value: 'age', class: 'text-xl-left body-1 black--text' },
          { text: 'Test Item Description', align: 'left', value: 'test_item_desc', class: 'text-xl-left body-1 black--text' },
          { text: 'Received Date', align: 'left', value: 'received_date', class: 'text-xl-left body-1 black--text' },
          { text: 'Due Date', align: 'left', value: 'due_date', class: 'text-xl-left body-1 black--text' },
          { text: 'Due Date Outlab', align: 'left', value: 'due_date_outlab', class: 'text-xl-left body-1 black--text' },
          { text: 'Sent Date', align: 'left', value: 'sent_date', class: 'text-xl-left body-1 black--text' },
          { text: 'Lead Time', align: 'left', value: 'lead_time', class: 'text-xl-left body-1 black--text' },
          { text: 'Complete Date', align: 'left', value: 'complete_date', class: 'text-xl-left body-1 black--text' },
          { text: 'remark', align: 'left', value: 'remark', class: 'text-xl-left body-1 black--text' },
        ]
      },
      offsetAppBar () {
        return this.getShowAppBar ? this.getAppBarHeight : 0
      }
    },
    methods: {
      selectLanguage (language) {
      },
      getVarReturn (value) {
        switch (value.childSend) {
          case 'CustomerBrowse':
            this.dialog.dialogBrowseCustomer = false
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browseCustomerCriteria':
                    this.criteria.custSkey = value.dataSelected[0]['cust_skey']
                    this.criteria.custName = value.dataSelected[0]['cust_name']
                    break
                }
            }
            break
          case 'SupplierBrowse':
            this.dialog.dialogBrowseSupplier = false
            switch (value.actionReturn) {
              case 'OK':
                switch (value.browseName) {
                  case 'browseSupplierCriteria':
                    this.criteria.vendorSkey = value.dataSelected[0]['vendor_skey']
                    this.criteria.vendorName = value.dataSelected[0]['vendor_name']
                    break
                }
            }
            break
        }
      },
      initialize () {
        this.vDataTable.selected = []
        this.vDataTable.editedIndex = -1
        this.vDataTable.editedItem = {
          win_name: '',
          window_comment: ''
        }
        this.vDataTable.defaultItem = {
          win_name: '',
          window_comment: ''
        }
      },
      openDialogCriteria () {
        this.dialog.dialogCriteria = true
      },
      browseCustomerCriteria () {
        this.dialog.dialogBrowseCustomer = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseCustomerCriteria'
        this.$refs.CustomerBrowse.retrieveCustomer()
      },
      browseSupplierCriteria () {
        this.dialog.dialogBrowseSupplier = true
        this.sendVar.singleSelect = true
        this.sendVar.browseName = 'browseSupplierCriteria'
        this.$refs.SupplierBrowse.retrieveSupplier()
      },
      clearCustomerCriteria () {
        this.criteria.custSkey = -1
        this.criteria.custName = ''
      },
      clearSupplierCriteria () {
        this.criteria.vendorSkey = -1
        this.criteria.vendorName = ''
      },
      clearDueDateFromToCriteria () {
        this.criteria.dueDateFromTo = []
      },
      clearReceivedDateFromToCriteria () {
        this.criteria.receivedDateFromTo = []
      },
      clearSentDateFromToCriteria () {
        this.criteria.sentDateFromTo = []
      },
      clearDueDateOutLabFromToCriteria () {
        this.criteria.dueDateOutLabFromTo = []
      },
      clearAll () {
        this.criteria.receivedDateFromTo = []
        this.criteria.dueDateFromTo = []
        this.criteria.sentDateFromTo = []
        this.criteria.dueDateOutLabFromTo = []
        this.criteria.completeDate = ''
        this.criteria.custSkey = -1
        this.criteria.custName = ''
        this.criteria.vendorSkey = -1
        this.criteria.vendorName = ''
        this.criteria.hn = ''
        this.criteria.complete = false
      },
      async complete () {
        if (this.vDataTable.selected.length > 0) {
          if (this.criteria.completeDate === '') {
            this.$swal({type: 'warning', title: 'Please Enter Complete Date'})
          } else {
            this.$swal({
              text: 'Are you sure you want to Complete?',
              type: 'question',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.$t('yes'),
              cancelButtonText: this.$t('no')
            }).then((result) => {
              if (result) {
                this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
                  this.dialog.dialogProgress = true
                  this.progressMessage = this.$t('waiting')
                  await this.axios.post(process.env.VUE_APP_API + '/lis_outLab_processing/updateSentTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
                    'order_skey': x.order_skey,
                    'test_item_skey': x.test_item_skey,
                    'complete_date': this.criteria.completeDate,
                  })
                  .then(response => {
                    if (response.data.isSuccess) {
                      this.retrieveOutLabProcessing()
                    } else {
                      this.$swal({type: 'error', title: response.data.reasonText})
                    }
                  })
                    .catch(e => {
                      this.$swal({type: 'error', title: e.message})
                    })
                  this.dialog.dialogProgress = false
                }.bind(this))
              }
            })
          }
        } else {
          this.$swal({type: 'warning', title: 'Please Select Data'})
        }
      },
      async VoidTestItem () {
        if (this.vDataTable.selected.length > 0) {
          this.$swal({
            text: 'Are you sure you want to Void Test Item?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
                this.dialog.dialogProgress = true
                this.progressMessage = this.$t('waiting')
                await this.axios.post(process.env.VUE_APP_API + '/lis_outLab_processing/updateSentVoidTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
                  'order_skey': x.order_skey,
                  'test_item_skey': x.test_item_skey
                })
                .then(response => {
                  if (response.data.isSuccess) {
                    this.retrieveOutLabProcessing()
                  } else {
                    this.$swal({type: 'error', title: response.data.reasonText})
                  }
                })
                .catch(e => {
                  this.$swal({type: 'error', title: e.message})
                })
                this.dialog.dialogProgress = false
              }.bind(this))
            }
          })
        } else {
          this.$swal({type: 'warning', title: 'Please Select Data'})
        }
      },
      async retrieveOutLabProcessing () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/lis_outLab_processing/retrieveOutLabProcessing' + process.env.VUE_APP_DATABASE_TYPE, {
          'criteria': this.criteria,
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.data = response.data.data
              this.initialize()
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
        this.dialog.dialogCriteria = false
      },
      close () {
        this.dialog.dialogAddEdit = false
        this.$nextTick(() => {
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        })
      },
      async save () {
        if (this.vDataTable.editedIndex > -1) {
          await this.updateCustomerIssueLog(this.vDataTable.editedItem)
        } else {
          await this.addCustomerIssueLog(this.vDataTable.editedItem)
        }
      }
    },
  }
  </script>